import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { GdViewType } from '../../typings/graphql-grid';
import {
    GEO_TYPES,
    PriceGeoType,
    PricePackageTargetingsCustom,
    PricePackageTargetingsFixed
} from '../../typings/pricePackages';

import './GridPricePackageTargetingsCell.css';
import * as keyset from './GridPricePackageTargetingsCell.i18n';

const i18n = i18nFactory(keyset);

export interface PricePackageTargetingsProps {
    targetingsFixed: PricePackageTargetingsFixed;
    targetingsCustom: PricePackageTargetingsCustom;
}

const BLOCK = 'grid-price-package-targetings-cell';

const getText = (type: PriceGeoType) => {
    switch (type) {
        case PriceGeoType.countries: {
            return i18n('countries');
        }
        case PriceGeoType.regions: {
            return i18n('regions');
        }
        case PriceGeoType.districts: {
            return i18n('districts');
        }
        default: {
            throw new Error('Geo type not supported');
        }
    }
};

export class GridPricePackageTargetingsCell extends React.PureComponent<PricePackageTargetingsProps> {
    render() {
        return (
            <div className={Bem.cls(BLOCK)}>
                {this.getViewTypes()}
                {this.getBehaviors()}
                {this.getGeoType()}
            </div>
        );
    }

    private getViewTypes() {
        const { viewTypes } = this.props.targetingsFixed;
        const viewTypesTexts = {
            [GdViewType.DESKTOP]: i18n('desktop-view'),
            [GdViewType.MOBILE]: i18n('mobile-view'),
            [GdViewType.NEW_TAB]: i18n('new-tab-view')
        };

        return viewTypes ? <span>{viewTypes.map(type => viewTypesTexts[type]).join(', ')}</span> : null;
    }

    private getBehaviors() {
        const { behaviors } = this.props.targetingsCustom;

        return behaviors && behaviors.length ? (
            <span>
                {this.getSeparator()}
                {i18n('ltv')}
            </span>
        ) : null;
    }

    private getGeoType() {
        const { geoType: typeCustom } = this.props.targetingsCustom;
        const { geoType: typeFixed } = this.props.targetingsFixed;

        const type = typeCustom || typeFixed;

        return type ? (
            <span>
                {this.getSeparator()}
                {getText(GEO_TYPES[type])}
            </span>
        ) : null;
    }

    private getSeparator() {
        return <span className={Bem.cls(BLOCK, 'separator')}>•</span>;
    }
}
